<template>
  <v-app>
    <v-main>
      <v-container>
        <v-btn @click="scheduleNotification">Schedule Notification</v-btn>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { LocalNotifications } from "@capacitor/local-notifications";

export default {
  name: "Upgrade",
  methods: {
    async scheduleNotification() {
      await LocalNotifications.requestPermissions();
      await LocalNotifications.schedule({
        notifications: [
          {
            title: "Test Notification",
            body: "This is a test notification",
            id: 1,
            schedule: { at: new Date(Date.now() + 1000 * 5) }, // 5 seconds from now
            sound: null,
            attachments: null,
            actionTypeId: "",
            extra: null,
          },
        ],
      });
    },
  },
};
</script>

<!-- <template>
  <div>
    <template v-if="this.data != null"> </template>
    <template v-else>
      <LoadingData />
    </template>

    <UpgradeCore />
  </div>
</template>

<script>
import UpgradeCore from "../components/upgrade/UpgradeCore.vue";

import { mapState } from "vuex";
import LoadingData from "../components/LoadingData.vue";

import { ServiceClient } from "../service_client/index.js";

export default {
  name: "ZZZTemplate",
  props: {},
  components: {
    LoadingData,
    UpgradeCore,
  },
  data() {
    return {
      timer: null,
      mobile: false,

      data: null,

      softwares: null,

      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
    };
  },
  created() {
    this.getBreakpoints();
    this.getData();
  },
  mounted() {
    this.pollData();

    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },

  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
  },
  methods: {
    onResize() {
      this.getBreakpoints();
    },
    getBreakpoints() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;

      if (this.windowWidth < 768) {
        this.mobile = true;
      } else {
        this.mobile = false;
      }
    },
    pollData() {
      this.timer = setInterval(() => {
        this.getData();
      }, 1000);
    },
    getData() {
      ServiceClient.dataCore(ServiceClient.getAPIUrl("upgrade"), null, null, "GET")
        .then((data) => {
          this.data = data;
        })
        .catch((error) => {
          this.data = ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);

    window.removeEventListener("resize", this.onResize);
  },
  destroyed() {},
};
</script>

<style scoped></style>
 -->
